import React from 'react'
import { useHistory, } from "react-router";
import leftarrow from "../../assets/Image/leftarrow.png"
import { useParams } from "react-router";


import "../../myfin_v2/css/bookclosure.css";
import { Button } from "../../myfin_v2/elements/Button";
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as SearchIcon } from "../../myfin_v2/assets/icons/search.svg";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";


export const MatrixNav = () => {
    const history = useHistory();
    const { workspaceId, companyId } = useParams();

    const breadcrumbItems = [
        {
            label: "Workspace name",
            link: `/bookclosure-entries/${workspaceId}/${companyId}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Book closure name",
            link: `/bookclosure-entries/${workspaceId}/${companyId}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        
        {
            label: "View FSCP Posting",
            link: `/bookclosure-entries/${workspaceId}/${companyId}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "FSCP Matrix", link: "", className: "headerLable" },
    ];

    return (
        <>
            <>
                <div className="fscp-header">
                    <Breadcrumb style="margin-right:auto"
                        addCls={"bgClr1"}
                        items={breadcrumbItems}
                        headerActions={<></>}
                    />
                    <SearchIcon width={20} height={20} />
                </div>
            </>
        </>
    )
}
